<template>
  <div class="tw-px-4 tw-py-2">
    <label v-if="label" class="tw-block tw-text-xs tw-font-medium tw-text-nc-text-secondary tw-mb-1.5">{{ label }}</label>
    <textarea
      ref="el"
      :value="modelValue"
      :placeholder="placeholder"
      :rows="rows"
      :readonly="readonly"
      class="tw-w-full tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-border tw-outline-none tw-transition-colors tw-resize-y placeholder:tw-text-nc-text-placeholder"
      :class="textareaClasses"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'NcTextarea',
  props: {
    modelValue: { type: String, default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    rows: { type: [Number, String], default: 3 },
    readonly: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  methods: {
    /** Focus the underlying textarea (handles platform focus consistently). */
    focus() {
      this.$refs.el?.focus();
    },
  },
  computed: {
    textareaClasses() {
      if (this.readonly) {
        return 'tw-bg-nc-bg-page tw-border-nc-border tw-text-nc-text-secondary tw-cursor-default tw-resize-none';
      }
      return 'tw-bg-nc-bg-input tw-border-nc-border tw-text-nc-text tw-shadow-nc-sm focus:tw-border-nc-primary focus:tw-ring-1 focus:tw-ring-nc-primary';
    },
  },
};
</script>
